import { render, staticRenderFns } from "./ModalCambiarBoletaAFactura.vue?vue&type=template&id=dcfa1462&scoped=true&lang=pug"
import script from "./ModalCambiarBoletaAFactura.vue?vue&type=script&lang=js"
export * from "./ModalCambiarBoletaAFactura.vue?vue&type=script&lang=js"
import style0 from "./ModalCambiarBoletaAFactura.vue?vue&type=style&index=0&id=dcfa1462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa1462",
  null
  
)

export default component.exports